<div class="main-wrapper">
	<div class="main-content">
		<!-- global markup for header -->
		<header class="header">
			<div class="content">
				<div class="header__block row">
					<div class="header__arrow col image no-print" (click)="history.back()">
						<img src="/assets/images/header/back-arrow.svg" alt="arrow" />
					</div>
					<div class="header__title col">{{ title$ | async }}</div>

					<div class="header__burger col image no-print" (click)="Restart()" style="text-decoration: underline">
						<b> איפוס </b>
					</div>
				</div>
			</div>
			<div class="report-table__row no-print">
				<div class="header__search header__search_small relative" style="width: 99%; margin: auto; margin-top: 10px">
					<form [formGroup]="form">
						<input class="header__search-input" type="text" placeholder="חפש" formControlName="ClientSearch" id="search-Input" style="text-align: center; direction: rtl" />
					</form>
					<button class="header__clear-icon" (click)="form.controls.ClientSearch.reset()"></button>
				</div>
				<span class="absolute" style="left: 50%; transform: translateX(-50%); color: white; padding-top: 4px">מציג ( {{ totalShown$ | async }} ) משימות</span>
			</div>
		</header>

		<!-- start markup for delete teuda confirmation popup -->

		<!--  dashboard-tables markup  -->
		<section class="dashboard-tables" style="margin-top: 30px">
			<div class="content">
				<div class="dashboard-tables__wrapper">
					<div class="dashboard-tables__row dashboard-tables__row_scroll margin-top">
						<div class="show-only-in-print" style="margin-bottom: 20px; font-size: larger; text-align: center">
							{{ filterPrintDisplay$ | async }}
						</div>
						<div class="flex justify-center align-center" style="min-height: 60px">
							<button mat-raised-button (click)="handleRowClick({ action: 'add' })" style="background: var(--valid-color); color: var(--secondary-color)">הוסף נהג</button>
						</div>
						<b>
							<section class="sticky-headers">
								<table class="report-table__table" [ngStyle]="{ height: 'calc(99vh - ' + (tableHeight || 0) + ')', 'min-width': null }" cellspacing="0">
									<thead class="report-table__table-head" #thead>
										<tr style="height: 54px">
											<th class="report-table__table-head-name">נהג</th>
											<th class="report-table__table-head-code">סוג</th>
											<th class="report-table__table-head-code">סיסמה</th>
											<th class="report-table__table-head-code">קו חלוקה</th>
											<th class="report-table__table-head-code">מס' רכב</th>
											<th class="report-table__table-head-code">פעולות</th>
										</tr>
									</thead>

									<tbody class="report-table__table-body custom-scrollbar" [ngStyle]="{ height: 'calc(99vh - ' + thead.offsetHeight + 'px - ' + (tableHeight || 1) + ')' }">
										<tr *ngFor="let driver of driversDisplay$ | async" class="clickable" (click)="handleRowClick({ action: 'edit', row: driver })">
											<td class="report-table__table-body-name">{{ driver.AgentID }} - {{ driver.UserName }}</td>
											<td class="report-table__table-body-quantity">{{ driver.Admin | adminToHebrewName }}</td>
											<td class="report-table__table-body-quantity">{{ driver.Password }}</td>
											<td class="report-table__table-body-quantity">{{ driver.DeliveryLine }}</td>
											<td class="report-table__table-body-quantity">{{ driver.CarNum }}</td>
											<td class="report-table__table-body-quantity">
												<button
													mat-raised-button
													(click)="handleRowClick({ action: 'delete', row: driver, e: $event })"
													style="background: var(--invalid-color); color: var(--secondary-color)"
												>
													מחק
												</button>
											</td>
										</tr>
									</tbody>
								</table>
							</section>
						</b>
					</div>
				</div>
			</div>
		</section>
	</div>

	<!-- end main menu markup -->
</div>

<!-- start sort popup -->

<!-- end sort popup -->

<!-- start clientcard popup -->

<div class="popup" *ngIf="shouldClientCardPopupShow" style="z-index: 556">
	<div class="overlay"></div>
	<div class="product-detail-popup popup__content fixed">
		<div class="product-detail__wrapper wrapper2">
			<div class="product-detail__item overflow" style="padding: 0">
				<div class="popup__close" (click)="toggleClientCardPopup()" style="width: 30px; height: 30px; background-color: black; position: fixed"></div>
				<app-clientcard></app-clientcard>
			</div>
		</div>
	</div>
</div>

<!-- end clientcard popup -->
